resetPaymentError